<script setup lang="ts">
import { cn } from "@/lib/utils";

// 1) Expect 'id' from the parent.
const props = defineProps<{ id: string }>();

/**
 * 2) Expose minimal commands & properties
 * so the resource editor can display this in its block gallery.
 */
defineExpose({
  commands: [],
  properties: {
    id: props.id,
    name: "Card Header",
    icon: "lucide:panel-top",
  },
  filter: ["Card Header Title", "Card Header Description"],
});
</script>

<template>
  <!-- Renders the ShadCN CardHeader, with a slot for nested content. -->
  <CardHeader :class="cn($attrs.class ?? '')">
    <slot />
  </CardHeader>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD_HEADER,
  icon: "lucide:panel-top",
  type: "Card Header",
  description: "Container block that renders a card header for nested elements.",
  default: {},
  categories: ["Layout"],
  filter: ["Card Header Title", "Card Header Description"],
  hiddenUntilFiltered: true,
  order: 12001,
};
</script>
